import React from 'react';

import { TopUserResult } from '../../../../components/molecules/Form/components/ComboBox';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import Btn, { BtnModifier } from '../../../../components/molecules/Btn';
import { Icons } from '../../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
// eslint-disable-next-line max-len
import { FormsComboboxMultiSelectListElement } from '../../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectListElement';
// eslint-disable-next-line max-len
import { FormsComboboxMultiselectSelection } from '../../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/FormsComboboxMultiselectSelection';
import FormMultiselectContainer, {
  FormMultiselectModifier,
} from '../../../../components/molecules/Form/components/FormMultiselect/FormMultiselect';
import { AddUserRoleParam } from './AddUser';
import { StateFacetItem } from '../../../../components/molecules/ResultListSettings/ResultListSettings';

type AddUserMultiSelectListItemType = {
  selectedResult: TopUserResult;
  removeResult: (item: TopUserResult) => void;
  rolesParam: AddUserRoleParam<'roles'>;
  userId: number;
};

export function AddUserMultiSelectListItem({
  selectedResult,
  removeResult,
  rolesParam,
  userId,
}: AddUserMultiSelectListItemType) {
  const id = useHtmlValidId();
  const { t } = useSonTranslation('FormsComboBoxMultiSelect');

  return (
    <>
      <FormsComboboxMultiSelectListElement>
        <FormsComboboxMultiselectSelection
          id={`recipient-${id}-${selectedResult.id}`}
          title={selectedResult.profileName}
        >
          <FormMultiselectContainer
            name={`memberships[${userId}].roles`}
            title={t('glossary:role_plural')}
            items={rolesParam.options as StateFacetItem[]}
            modifier={FormMultiselectModifier.ROLE_CHANGE_FORM}
          />
          <Btn
            modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
            svgSpriteId={Icons.DELETE_X_SMALL}
            type="button"
            text={t('resultlist.deleteButtonText', { itemName: selectedResult.profileName })}
            titleText={t('resultlist.deleteButtonTitleText', { itemName: selectedResult.profileName })}
            hiddenText
            tooltipPlacement={TooltipPlacement.TOP}
            onClick={() => {
              removeResult(selectedResult);
            }}
          />
        </FormsComboboxMultiselectSelection>
      </FormsComboboxMultiSelectListElement>
      <input type="hidden" name={`memberships[${userId}].userId`} value={selectedResult.id} />
    </>
  );
}
